import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LAYLO_URL } from "@/data/site";

// Text/email list CTA. Sierra's build embeds her live Laylo drop here
// (LayloSignupEmbed); Jenn has no list platform yet (she's "not sure yet"
// on Laylo, currently using Linktree), so this renders an honest
// "opening soon" state until LAYLO_URL is set in data/site.js — then it
// becomes a real button with no other code changes. `compact` drops the
// Community link (used on the Community page itself).
export const ListSignup = ({ compact = false, label = "Join My Inner Circle" }) =>
  LAYLO_URL ? (
    <a
      href={LAYLO_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="list-signup-link"
      className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[var(--sm-gold)] px-6 py-2.5 font-body text-sm font-medium text-black transition-colors hover:bg-[var(--sm-gold-light)]"
    >
      {label} <ArrowUpRight size={15} />
    </a>
  ) : (
    <div data-testid="list-signup-pending" className="flex flex-col items-center gap-3">
      <span className="inline-flex shrink-0 cursor-default items-center gap-2 rounded-full border border-[var(--sm-gold)]/50 px-6 py-2.5 font-body text-sm font-medium text-[var(--sm-gold-light)]">
        Text list opening soon
      </span>
      {!compact && (
        <Link
          to="/community"
          className="font-accent text-xs uppercase tracking-[0.18em] text-white/50 underline decoration-white/20 underline-offset-4 transition-colors hover:text-[var(--sm-gold-light)]"
        >
          Meanwhile, find her on socials
        </Link>
      )}
    </div>
  );
